import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from "react";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
export default (function (props) {
  var value = props.value,
    setValue = props.setValue,
    config = props.config,
    readonly = props.readonly,
    placeholder = props.placeholder,
    customProps = props.customProps,
    maxLength = props.maxLength,
    errorMessage = props.errorMessage;
  var renderSize = config.settings.renderSize;
  var onChange = useCallback(function (e) {
    var val = e.target.value;
    if (val === "") val = undefined; // don't allow empty value

    setValue(val);
  }, [setValue]);
  var textValue = value || "";
  return /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(TextField, _extends({
    variant: "standard",
    value: textValue,
    placeholder: !readonly ? placeholder : "",
    InputProps: {
      readOnly: readonly
    },
    inputProps: {
      maxLength: maxLength
    },
    disabled: readonly,
    onChange: onChange,
    size: renderSize
  }, customProps)));
});